import { render, staticRenderFns } from "./SalesmanEvent.vue?vue&type=template&id=67242268&"
import script from "./SalesmanEvent.vue?vue&type=script&lang=js&"
export * from "./SalesmanEvent.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports